import type { EnhancedStore } from '@reduxjs/toolkit';

const GLOBAL_STORE_KEY = '__DFTAMS_APP_STORE__';

/**
 * Store reference for the app Redux store.
 * This allows access to the store outside of React components.
 */
export const setAppStore = (store: EnhancedStore) => {
  (globalThis as unknown as Record<string, unknown>)[GLOBAL_STORE_KEY] = store;
};

export const getAppStore = () => {
  return (globalThis as unknown as Record<string, unknown>)[
    GLOBAL_STORE_KEY
  ] as EnhancedStore | undefined;
};
